import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
  useContext,
} from "react";
import TextInput from "../../framework/TextInput";
import CommonModal from "./CommonModal";

const CommonPasswordModal = (props) => {
  const { onOk = () => {}, onCancel = () => {}, onError = () => {} } = props;

  const modalPasswordRef = useRef(null);
  const [passwordValue, setPasswordValue] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    setShowPassword(true);
  }, []);
  useEffect(() => {
    if (showPassword) {
      modalPasswordRef?.current?.focus();
    }
  }, [showPassword]);

  const okHandler = useCallback(() => {
    if (passwordValue === "pro") {
      setShowPassword(false);
      onOk();
    } else {
      modalPasswordRef?.current?.focus();
      onError("Invalid Password.");
    }
  }, [onError, onOk, passwordValue]);
  const cancelHandler = useCallback(() => {
    setShowPassword(false);
    onCancel();
  }, [onCancel]);
  const listener = useCallback(
    (event) => {
      const key = event.key?.toLowerCase();
      if (key === "enter") {
        if (passwordValue) {
          okHandler();
        }
      }
    },
    [okHandler, passwordValue]
  );
  useEffect(() => {
    setShowPassword(true);
  }, []);
  useEffect(() => {
    setTimeout(() => {
      modalPasswordRef?.current?.focus();
    }, 300);
  }, []);
  useEffect(() => {
    if (showPassword) document.addEventListener("keyup", listener, false);
    return () => {
      document.removeEventListener("keyup", listener, false);
    };
  }, [listener, showPassword]);
  return (
    <CommonModal
      type="error"
      open={showPassword}
      showCloseIcon={false}
      title="Please enter password to proceed."
      content={
        <TextInput
          label="Password"
          id="modal_password"
          ref={modalPasswordRef}
          type="password"
          placeholder="Password"
          variant="standard"
          // InputProps={{ readOnly: true }}
          value={passwordValue}
          onChange={(e) => {
            setPasswordValue(e.target.value);
          }}
          inputProps={{
            "data-markers": JSON.stringify({
              left: "modal_ok_button",
              right: "modal_ok_button",
              down: "modal_ok_button",
              up: "modal_password",
            }),
          }}
        />
      }
      focusContentMarker="modal_password"
      onOk={okHandler}
      onCancel={cancelHandler}
      onEscape={cancelHandler}
    />
  );
};

export default CommonPasswordModal;
